import { render, staticRenderFns } from "./SuppliersCategoriesList.vue?vue&type=template&id=3396df9c&scoped=true"
import script from "./SuppliersCategoriesList.vue?vue&type=script&lang=js"
export * from "./SuppliersCategoriesList.vue?vue&type=script&lang=js"
import style0 from "./SuppliersCategoriesList.vue?vue&type=style&index=0&id=3396df9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3396df9c",
  null
  
)

export default component.exports